"use strict";
function Visitor() {}

Visitor.prototype = {
  constructor: Visitor,

  accept: function(object) {
    return this[object.type](object);
  }
};

exports["default"] = Visitor;


//////////////////
// WEBPACK FOOTER
// /work/node_modules/handlebars/dist/cjs/handlebars/compiler/visitor.js
// module id = 13
// module chunks = 0 1 2